import { useEffect, useState } from 'react'
import { Button } from '@nazka/nazka.mapframe.components'
import { useTranslation } from '@utils/i18n/i18n.consumers';
import { useLocation, useNavigate } from 'react-router-dom'
import { moduleSessions } from '@App/components/CourseRelatedComponents/course-related-components.constants'
import StepperComponent from '@App/components/CourseRelatedComponents/StepperComponent/StepperComponent'
import { completePart, getCompletedParts } from '@App/components/CourseRelatedComponents/course-related-components.util'
import RenderPartsInTemplates from '@App/components/CourseRelatedComponents/RenderPartsInTemplates/RenderPartsInTemplates'

import './course-content.styl'

export default function CourseContent() {
  const { t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()

  const locationPath = location.pathname.split('/')
  const moduleId = Number(locationPath[3])
  const sessionId = Number(locationPath[5])
  const partId = Number(locationPath[7])
  const selectedModuleData = moduleSessions.find(item => item.id === moduleId)
  const selectedSessionData = selectedModuleData.sessions.find(item => item.id === sessionId)
  const [selectedPartIndex, setSelectedPartIndex] = useState(partId - 1)
  const [completedParts, setCompletedParts] = useState(() => getCompletedParts(moduleId, sessionId))

  useEffect(() => {
    setSelectedPartIndex(partId - 1);
  }, [partId]);

  const handleEndSession = () => {
    const currentPartId = selectedSessionData.parts[selectedPartIndex].id
    if (!completedParts.includes(currentPartId)) {
      completePart(moduleId, sessionId, currentPartId, selectedSessionData.parts.length, selectedModuleData.sessions.length)
      setCompletedParts(prev => (prev.includes(currentPartId) ? prev : [...prev, currentPartId]))
    }

    if (selectedModuleData.sessions.length === sessionId) {
      navigate(`/learn/module/${moduleId}/completion`)
    } else {
      navigate(`/learn/module/${moduleId}`)
    }
  }

  const handleNextPart = () => {
    const currentPartId = selectedSessionData.parts[selectedPartIndex].id
    if (!completedParts.includes(currentPartId)) {
      completePart(moduleId, sessionId, currentPartId, selectedSessionData.parts.length)
      setCompletedParts(prev => (prev.includes(currentPartId) ? prev : [...prev, currentPartId]))
    }
    navigate(`/learn/module/${moduleId}/session/${sessionId}/part/${partId + 1}`)
    setSelectedPartIndex(selectedPartIndex + 1)
  }

  return (  
    <div className="course-content">
      <div className="course-content__header">
        <StepperComponent selectedSessionData={selectedSessionData} completedParts={completedParts} currentPartId={partId} />
        <div className="course-content__btn-wrapper">
          <Button
            layout="outlined"
            css={{
              borderRadius: '8px',
              '&:hover': {
                color: 'white',
              },
            }}
            onClick={() => {
              if (selectedPartIndex === 0) {
                navigate(`/learn/module/${moduleId}`)
              } else {
                navigate(`/learn/module/${moduleId}/session/${sessionId}/part/${partId - 1}`)
                setSelectedPartIndex(selectedPartIndex - 1)
              }
            }}
          >
            {t('Go back')}
          </Button>
          <Button
            css={{
              borderRadius: '8px',
              color: 'white',
              '&:hover': {
                color: 'white',
              },
            }}
            onClick={() => (selectedSessionData.parts.length - 1 === selectedPartIndex ? handleEndSession() : handleNextPart())}
          >
            {selectedSessionData.parts.length - 1 === selectedPartIndex ? t('End Session') : t('Next')}
          </Button>
        </div>
      </div>
      <div className="course-content__pages-wrapper">
        <RenderPartsInTemplates selectedPart={selectedSessionData.parts[selectedPartIndex]} />
      </div>
    </div>
  )
}
